<template>
    <li>
        <label class="check_wrap">
            <input type="checkbox" v-model="employee.isSelected" @change="action_selectEmployee" />
            <span class="checkmark"></span>
            {{ employee.title }}
        </label>
    </li>
</template>

<script>
import { deepCopy } from '@/util/deep-copy'
import { useManagingWorkers } from '@/composables/use-managing-workers'

export default {
    setup() {
        const { updateEmployeesSelection } = useManagingWorkers()
        return { updateEmployeesSelection }
    },
    data() {
        return {
        }
    },
    props: {
        employee: {
            type: Object,
            required: true
        },
        handle_departmentUpdate: {
            type: Function,
            required: true
        }
    },
    methods: {
        action_selectEmployee() {
            let employee = deepCopy(this.employee)
            this.updateEmployeesSelection([employee])
            // 부서의 isSelected를 업데이트
            this.handle_departmentUpdate()
        }
    }
}
</script>

<style lang="scss" scoped></style>
